import {createAsyncThunk} from "@reduxjs/toolkit";
import {handlerError} from "../../../store/handleError";
import {machineryTelemetryAPI, ITelemetryDashboard} from "../api";
import {
    ITelemetryPoint,
    ITelemetryQuery,
} from "../../../models/IMachineryTelemetry";
import axios from "axios";

// ── Единый запрос дашборда (summary + все истории + journal + daily-*) ───────

export const fetchTelemetryDashboard = createAsyncThunk<
    ITelemetryDashboard,
    ITelemetryQuery,
    { rejectValue: string }
>(
    "machinery_telemetry/dashboard",
    async ({machineryId, from, to}, {rejectWithValue, signal, dispatch}) => {
        try {
            return await machineryTelemetryAPI.getDashboard(
                machineryId,
                from,
                to,
                signal, // ← передаём AbortSignal из RTK
            );
        } catch (e: unknown) {
            if (
                (e instanceof DOMException && e.name === "AbortError") ||
                axios.isCancel(e)
            ) {
                throw e;
            }
            // 402 уже обработан в axios interceptor — реджектим без шума
            if (axios.isAxiosError(e) && e.response?.status === 402) {
                return rejectWithValue("billing_restricted");
            }
            return rejectWithValue(handlerError(e));
        }
    }
);

// ── Последняя телеметрия (зависит только от machineryId) ────────────────────

export const fetchLatestTelemetry = createAsyncThunk<
    ITelemetryPoint | null,
    string,
    { rejectValue: string }
>(
    "machinery_telemetry/latest",
    async (machineryId, {rejectWithValue, signal}) => {
        try {
            return await machineryTelemetryAPI.getLatest(machineryId, signal);
        } catch (e: unknown) {
            if (e instanceof DOMException && e.name === "AbortError") throw e;
            if (axios.isAxiosError(e) && e.response?.status === 402) {
                return rejectWithValue("billing_restricted");
            }
            return rejectWithValue(handlerError(e));
        }
    },
);